export default "__VITE_ASSET__BinG$9uY__"